/* eslint-disable max-statements */
/* eslint-disable max-lines */
import { OptionItemType } from "../../../../../../../_webui/layout/components/Select/models"
import { Routers } from "../../../../../../../constant/Routers"
import { AxiosErrorType } from "../../../../../../../infrastructure/axiosError/models"
import { CitiesResType } from "../../../../../../../infrastructure/handlers/countries/models"
import { GeneralMastersResType } from "../../../../../../../infrastructure/handlers/generalMasters/models"
import { getValueByLanguage } from "../../../../../../../utils/getValueByLanguage"
import { pushStateError } from "../../../../../../../utils/pushStateError"
import { scheduleApi } from "../../../../apis"
import {
  AreasAndCountriesResType,
  SchedulesListDataType,
  SchedulesListPostType,
  UseSchedulesListApiProps,
} from "../../../../models/list"
import { SchedulesSearchFormDataType } from "../../../../models/list/search"
import { useVariablesApi } from "../useVariablesApi"
import { convertSearchDataSubmit } from "./convertSearchDataSubmit"
import { getDataSearchBasic } from "./getDataSearchBasic"
import { getDataSubmit } from "./getDataSubmit"
import { convertDataSource } from "./convertDataSource"
import { DepartmentsResType } from "../../../../../../../infrastructure/handlers/departments/models"
import { departmentsApi } from "../../../../../../../infrastructure/handlers/departments"
import { GeneralCode } from "../../../../../../../constant/GeneralCode"
import { generalMastersApi } from "../../../../../../../infrastructure/handlers/generalMasters"
import { countriesApi } from "../../../../../../../infrastructure/handlers/countries"
import { checkEmptySearchCondition } from "../../utils/checkEmptySearchCondition"
import { DefaultOptionType } from "antd/lib/cascader"

const { DPTD } = GeneralCode
const { SCR210, SCR210_USER_SEARCH, SCR973 } = Routers

export const useApi = ({
  isPathnameTravelers,
  isRoleSubAdmin,
}: UseSchedulesListApiProps) => {
  const {
    arrivalCities,
    countryToTravelList,
    dataSource,
    dataSourceSelected,
    departments,
    dispatchType,
    dispatchTypeAll,
    dispatchTypeDetail,
    form,
    fullName,
    handleCancelEmptySearchCondition,
    handleOpenEmptySearchCondition,
    handleSetDefaultSortedInfo,
    isDisabledBtnCreateOrSend,
    isDisabledBtnDelete,
    isDisabledBtnRefer,
    isDisabledDispatchTypeDetail,
    isLoadingLayout,
    isLoadingTable,
    isOpenEmptySearchCondition,
    isPathnameAttentionsOrSafeties,
    isPathnameSchedules,
    isResetTable,
    onChange,
    onChangeTable,
    pathname,
    perItem,
    purposeTravel,
    push,
    rowSelection,
    searchCondition,
    selectedRowKeys,
    setArrivalCities,
    setCountryToTravelList,
    setDataSource,
    setDepartments,
    setDispatchType,
    setDispatchTypeAll,
    setDispatchTypeDetail,
    setIsDisabledDispatchTypeDetail,
    setIsLoadingLayout,
    setIsLoadingTable,
    setIsResetTable,
    setPurposeTravel,
    setSearchCondition,
    setTravelerId,
    sortedInfo,
    state,
    travelScheduleId,
    travelerId,
    userInformation,
  } = useVariablesApi(isRoleSubAdmin)

  const getSchedules = async (data: SchedulesListPostType) => {
    const _data = getDataSubmit({
      data,
      isFromSCR114UserSearch: pathname === SCR210_USER_SEARCH,
      isFromSCR115: state?.isFromSCR115,
      pathname,
      searchCondition: state?.searchCondition,
      travelerId:
        data?.["travelerId" as keyof SchedulesListPostType] ?? travelerId,
      userInformation,
    })

    handleSetDefaultSortedInfo()
    // APIを呼び出し、「渡航予定情報の一覧」のデータ一覧を取得する。
    await scheduleApi
      .getSchedules(_data)
      .then((res: SchedulesListDataType[]) => {
        const data = convertDataSource(res)
        setDataSource(data)
        document.getElementById("title-right")?.focus()
      })
      .catch((error: AxiosErrorType) => {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        const stateError = pushStateError(error)
        push({ pathname: SCR973, state: stateError })
      })
      .finally(() => {
        setIsLoadingLayout(false)
        setIsLoadingTable(false)
      })
  }

  const onFinish = (values: SchedulesSearchFormDataType) => {
    const dataSearch = getDataSearchBasic(values)
    const data = convertSearchDataSubmit({
      isPathnameAttentionsOrSafeties,
      isPathnameSchedules,
      pathname,
      searchCondition: dataSearch,
      userInformation,
      values,
    })

    setIsResetTable(true)
    setIsLoadingTable(true)
    onChange(1, 25)
    setTimeout(async () => {
      setSearchCondition({
        ...dataSearch,
        arrivalDateTime: "",
        departureDateTime: "",
      })

      setIsResetTable(false)
      await getSchedules(data)
    }, 500)
  }

  const handleSearch = (values: SchedulesSearchFormDataType) => {
    if (checkEmptySearchCondition(values) && isPathnameTravelers) {
      handleOpenEmptySearchCondition()
    } else {
      onFinish(values)
    }
  }

  const onChangeDispatchType = (
    value: string,
    dispatchTypes?: GeneralMastersResType[],
  ) => {
    const _dispatchTypeAll = dispatchTypeAll.length
      ? dispatchTypeAll
      : dispatchTypes
    const _dispatchTypeDetail: DefaultOptionType[] =
      _dispatchTypeAll
        ?.filter((item) => item.key2 === value)
        .map((item) => ({
          label: String(getValueByLanguage(item.value1, item.value2)),
          value: item.key1,
        })) || []
    setDispatchTypeDetail(_dispatchTypeDetail)
    setIsDisabledDispatchTypeDetail(!value)
  }

  const getData = () => {
    const getPurposeTravelAPI: Promise<GeneralMastersResType[]> =
      scheduleApi.getPurposeTravel()
    const getAllDepartments: Promise<DepartmentsResType[]> =
      departmentsApi.getAllDepartments()
    const getDispatchTypeAll: Promise<GeneralMastersResType[]> =
      generalMastersApi.getGeneralMaster(DPTD)

    const isGetByPermission = pathname !== SCR210 && isRoleSubAdmin
    const getAreas: Promise<AreasAndCountriesResType[]> =
      scheduleApi.getAreas(isGetByPermission)

    Promise.all([
      getPurposeTravelAPI,
      getAllDepartments,
      getDispatchTypeAll,
      getAreas,
    ])
      .then(async (res) => {
        const _purposeTravel: OptionItemType[] = res[0].map((item) => ({
          text: String(getValueByLanguage(item.value1, item.value2)),
          value: item.key3,
        }))
        setPurposeTravel(_purposeTravel)
        const _departments: OptionItemType[] = res[1].map((item) => ({
          text: String(
            getValueByLanguage(
              item.departmentNameJapan,
              item.departmentNameEnglish,
            ),
          ),
          value: item.bumonCd,
        }))
        setDepartments(_departments)
        setDispatchTypeAll(res[2])
        const _dispatchType = res[2]
          .filter(
            (item, index, self) =>
              index === self.findIndex((_item) => _item.key2 === item.key2),
          )
          ?.map((item) => ({
            text: String(getValueByLanguage(item.value3, item.value4)),
            value: item.key2,
          }))
        setDispatchType(_dispatchType)
        if (searchCondition?.dispatchType)
          onChangeDispatchType(searchCondition.dispatchType, res[2])

        const _areasAndCountries = res[3].map(
          ({ areaCode, areaName, countries }) => ({
            children: countries.map(({ countryCode, countryName }) => ({
              label: countryName,
              value: countryCode,
            })),
            label: areaName,
            value: areaCode,
          }),
        )
        setCountryToTravelList(_areasAndCountries)
      })
      .catch((error: AxiosErrorType) => {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        const stateError = pushStateError(error)
        push({ pathname: SCR973, state: stateError })
      })
      .finally(() => {
        const pathnameList = [SCR210, SCR210_USER_SEARCH]
        if (!pathnameList.includes(pathname) && !state?.searchCondition) {
          setIsLoadingLayout(false)
          setIsLoadingTable(false)
        }
      })
  }

  const getArrivalCities = (arrivalCityCode: string) => {
    if (!arrivalCityCode) {
      setArrivalCities([])
    } else {
      countriesApi
        .getCitiesByCountry(arrivalCityCode)
        .then((res: CitiesResType[]) => {
          const optionItem: OptionItemType[] = res.map((item) => ({
            text: item.cityDistrict,
            value: item.cityCode,
          }))
          setArrivalCities(optionItem)
        })
        .catch((error: AxiosErrorType) => {
          // 「SCR973_エラー情報の表示画面」に遷移する。
          const state = pushStateError(error)
          push({ pathname: SCR973, state })
        })
    }
  }

  return {
    arrivalCities,
    countryToTravelList,
    dataSource,
    dataSourceSelected,
    departments,
    dispatchType,
    dispatchTypeDetail,
    form,
    fullName,
    getArrivalCities,
    getData,
    getSchedules,
    handleCancelEmptySearchCondition,
    handleOpenEmptySearchCondition,
    handleSearch,
    isDisabledBtnCreateOrSend,
    isDisabledBtnDelete,
    isDisabledBtnRefer,
    isDisabledDispatchTypeDetail,
    isLoadingLayout,
    isLoadingTable,
    isOpenEmptySearchCondition,
    isPathnameAttentionsOrSafeties,
    isResetTable,
    onChange,
    onChangeDispatchType,
    onChangeTable,
    onFinish,
    perItem,
    purposeTravel,
    rowSelection,
    searchCondition,
    selectedRowKeys,
    setIsDisabledDispatchTypeDetail,
    setIsLoadingLayout,
    setIsLoadingTable,
    setSearchCondition,
    setTravelerId,
    sortedInfo,
    travelScheduleId,
    userInformation,
  }
}
